import { Box, Container, Typography, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ScrollToTopButton from "../HomePage/Scrolltotop/ScrollToTopButton";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import HeaderSection from "../../components/Blog/HeaderSection";
import BlogContentSection from "../../components/Blog/BlogContentSection";
import ImageSection from "../../components/Blog/ImageSection";
import blogJson from "./Data/allBlogs.json";
import { normalizeBlogContent } from "./blogHelpers/normalizeBlogContent";
import MediaTextSection from "../../components/Blog/MediaTextSection";
import { api } from "../../api/client";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const extractLeaves = (nodes = []) => {
  let leaves = [];

  nodes?.forEach((n) => {
    if (n.text !== undefined) {
      leaves.push(n);
    } else if (n.type === "link") {
      leaves.push(n); // keep link node
    } else if (n.children) {
      leaves = leaves.concat(extractLeaves(n.children));
    }
  });

  return leaves;
};

function BlogDetails() {
  const { slug } = useParams();
  const [blogData, setBlogData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const location = useLocation();
  const blogId = location.state?.blogId;

  console.log("Blog slug:", slug);
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the window to the top when the component mounts
  }, []);

  useEffect(() => {
    const fetchBlogDetail = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await api.get(`/blog/slug/${slug}`);
        setBlogData(res.data.data);
      } catch (err) {
        setError("Failed to fetch blog details");
      } finally {
        setLoading(false);
      }
    };

    if (blogId) {
      fetchBlogDetail();
    }
  }, [blogId]);

  const content = blogData?.Content?.data?.[0]?.BlogContent || [];

  // useEffect(() => {
  //   const fetchBlogDetail = async () => {
  //     try {
  //       setLoading(true);
  //       setError(null);
  //       const response = await axios.get(`https://strapi.dwebbox.com/api/dwebboxes?filters[id][$eq]=${id}&populate[Content][populate]=*`);
  //       console.log('Blog Detail Response:', response.data.data[0]);
  //       setBlogData(response.data.data[0]);

  //     } catch (error) {
  //       console.error('Error fetching blog details:', error);
  //       setError('Failed to fetch blog details. Please try again later.');
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (id) {
  //     fetchBlogDetail();
  //   }
  // }, [id]);

  // Format date
  const formattedDate = blogData.publishedAt
    ? new Date(blogData.publishedAt).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "";

  // Loading state
  if (loading) {
    return (
      <Box>
        <ScrollToTopButton />
        <Navbar />
        <Box sx={{ width: "100%", background: "#181818", minHeight: "100vh" }}>
          <Container
            component="main"
            sx={{
              pt: 10,
              pb: 10,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "50vh",
            }}
          >
            <CircularProgress sx={{ color: "#fff" }} />
          </Container>
        </Box>
      </Box>
    );
  }

  // Error state
  if (error) {
    return (
      <Box>
        <ScrollToTopButton />
        <Navbar />
        <Box sx={{ width: "100%", background: "#181818", minHeight: "100vh" }}>
          <Container component="main" sx={{ pt: 10, pb: 10 }}>
            <Typography
              variant="h5"
              sx={{ color: "#fff", textAlign: "center" }}
            >
              {error}
            </Typography>
          </Container>
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      <Helmet>
        <title>{blogData.Title || "Blog"} | Dwebbox</title>
        <meta name="description" content={blogData.description || "Read the latest news and insights from Dwebbox."} />
        <link rel="canonical" href={`https://dwebbox.com/blogs/${slug}`} />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content={blogData.Title} />
        <meta property="og:description" content={blogData.description} />
        <meta property="og:url" content={`https://dwebbox.com/blogs/${slug}`} />
        {blogData.thumbnail && <meta property="og:image" content={blogData.thumbnail} />}
        <meta property="og:type" content="article" />

        {/* Structured Data (Schema.org) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": blogData.Title,
            "image": blogData.thumbnail,
            "author": {
              "@type": "Organization",
              "name": "Dwebbox"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Dwebbox",
              "logo": {
                "@type": "ImageObject",
                "url": "https://dwebbox.com/logo192.png"
              }
            },
            "datePublished": blogData.publishedAt,
            "description": blogData.description
          })}
        </script>
      </Helmet>
      <ScrollToTopButton />
      <Navbar />

      <Box sx={{ width: "100%", background: "#181818", minHeight: "100vh" }}>
        {/* <Container component="main" sx={{ pt: 10, pb: 10 }}>
          
          

          

        </Container> */}

        <Box
          sx={{
            px: { xs: 2, md: 4 },
            py: { xs: 4, md: 6 },
          }}
        >
          {/* <Box height={"27.5rem"}>
              <img
                src={about2}
                width={"100%"}
                height={"100%"}
                style={{ objectFit: "fill" }}
              />
            </Box> */}
          {/* <HeaderSection
            title={blogData.Title}
            description={blogData.description}
          /> */}
          <Box>
            {content.map((block, index) => {
              // -------- PARAGRAPH --------
              if (block.type === "paragraph") {
                const isParagraphEmpty =
                  !block.children ||
                  (block.children.length === 1 && block.children[0].text === "");
                return (
                  <Typography
                    key={index}
                    sx={{
                      mb: 2,
                      textAlign: block.align || "left",
                      color: "#fff",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {isParagraphEmpty ? <br /> : block.children?.map((child, i) => {
                      // LINK
                      if (child.type === "link") {
                        return (
                          <a
                            key={i}
                            href={child.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#2563eb",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            {child.children?.map((leaf, j) => {
                              let el = leaf.text;

                              if (leaf.bold) el = <strong>{el}</strong>;
                              if (leaf.italic) el = <em>{el}</em>;
                              if (leaf.underline) el = <u>{el}</u>;

                              return (
                                <span
                                  key={j}
                                  style={{
                                    fontSize: leaf.fontSize || "14px",
                                    color: leaf.color || "inherit",
                                    whiteSpace: "pre-wrap",
                                  }}
                                >
                                  {el}
                                </span>
                              );
                            })}
                          </a>
                        );
                      }

                      // NORMAL TEXT
                      let el = child.text;

                      if (child.bold) el = <strong>{el}</strong>;
                      if (child.italic) el = <em>{el}</em>;
                      if (child.underline) el = <u>{el}</u>;

                      return (
                        <span
                          key={i}
                          style={{
                            fontSize: child.fontSize || "14px",
                            color: child.color || "inherit",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {el}
                        </span>
                      );
                    })}
                  </Typography>
                );
              }

              // -------- IMAGE --------
              if (block.type === "image") {
                return (
                  <Box key={index} sx={{ my: 4, textAlign: "center" }}>
                    <img
                      src={block.url}
                      alt=""
                      style={{
                        width: block.width || "100%",
                        borderRadius: "12px",
                        maxWidth: "100%",
                      }}
                    />
                  </Box>
                );
              }

              // -------- MEDIA TEXT --------
              if (block.type === "mediaText") {
                const isLeft = block.layout === "image-left";

                return (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: {
                        xs: "column",
                        md: isLeft ? "row" : "row-reverse",
                      },
                      gap: 3,
                      my: 4,
                    }}
                  >
                    <Box sx={{ width: { md: block.image.width } }}>
                      <img
                        src={block.image.url}
                        alt=""
                        style={{
                          width: "100%",
                          borderRadius: "12px",
                        }}
                      />
                    </Box>

                    <Box sx={{ flex: 1 }}>
                      {block.children?.map((child, i) => {
                        const leaves = extractLeaves(child.children || []);

                        return (
                          <Typography 
                            key={i} 
                            sx={{ 
                              mb: 2, 
                              color: "#fff",
                              whiteSpace: "pre-wrap"
                            }}
                          >
                            {leaves.map((leaf, j) => {
                              // LINK
                              if (leaf.type === "link") {
                                return (
                                  <a
                                    key={j}
                                    href={leaf.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#2563eb",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {leaf.children?.map((c, k) => {
                                      let el = c.text;

                                      if (c.bold) el = <strong>{el}</strong>;
                                      if (c.italic) el = <em>{el}</em>;
                                      if (c.underline) el = <u>{el}</u>;

                                      return <span key={k}>{el}</span>;
                                    })}
                                  </a>
                                );
                              }

                              // NORMAL TEXT
                              let el = leaf.text;

                              if (leaf.bold) el = <strong>{el}</strong>;
                              if (leaf.italic) el = <em>{el}</em>;
                              if (leaf.underline) el = <u>{el}</u>;

                              return (
                                <span
                                  key={j}
                                  style={{
                                    fontSize: leaf.fontSize || "14px",
                                    color: leaf.color || "inherit",
                                    fontWeight: leaf.bold ? "700" : undefined,
                                    fontStyle: leaf.italic
                                      ? "italic"
                                      : undefined,
                                    textDecoration: leaf.underline
                                      ? "underline"
                                      : undefined,
                                    whiteSpace: "pre-wrap",
                                  }}
                                >
                                  {el}
                                </span>
                              );
                            })}
                          </Typography>
                        );
                      })}
                    </Box>
                  </Box>
                );
              }

              return null;
            })}
          </Box>

          <Box style={{ marginTop: "0.8rem", marginBottom: "2rem" }}>
            <Typography
              style={{
                fontFamily: "Montserrat ,sans-serif",
                fontSize: "1rem",
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "1.2",
                color: "#ffffff",
                // backgroundcolor: "#ffffff",
              }}
            >
              Written by Team D-WebBox <span>{formattedDate}</span>
            </Typography>
          </Box>
        </Box>
      </Box>

      <Footer />
    </Box>
  );
}

export default BlogDetails;
